import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useIsLoggedIn, useUserId } from '~/context/common/UserContext';
import { useVdpPricing } from '~/context/vdp/UserVehicleContext';
import fetchCreditStatusNoTrade from '~/services/vdp/fetchCreditStatus';
import { generateErrorLogger } from '~/utilities/loggers';
import SptPriceDetailsContext from '../../SptPriceDetailsContext';

export default function useGetCreditStatus() {
  const {
    creditStatus: { setData, setError, setLoading, setLoaded },
    creditStatusRequest,
    setCoApplicantApplied
  } = useContext(SptPriceDetailsContext);
  const { financeInfo: { hasCoApplicant = false } = {} } = useVdpPricing();
  const userId = useUserId();
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      if (!isLoggedIn || !hasCoApplicant) {
        setLoaded();

        return;
      }

      setLoading();
      fetchCreditStatusNoTrade(userId, controller)
        .then(({ data }) => {
          setData(data);
          setCoApplicantApplied(Boolean(data?.coApplicantToggleOn));
        })
        .catch(
          generateErrorLogger(
            'Get credit status',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      creditStatusRequest,
      hasCoApplicant,
      isLoggedIn,
      setCoApplicantApplied,
      setData,
      setError,
      setLoaded,
      setLoading,
      userId
    ]
  );
}
